export const CLINIC_SUPPLIER_ROUTE_PARAM_MAP_KEY = ':lieferantId';
